import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    nlpEmptyTitle: string;
    nlpEmptyDescription: string;
    nlpEmptyButtonLabel: (count: number) => string;
    lexicalEmptyTitle: string;
    lexicalEmptyDescription: string;
    lexicalEmptyButtonLabel: (count: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title shown when no AI results are found */
            nlpEmptyTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.nlpEmptyTitle?c=1wnsd0jijp69y", defaultMessage: "No AI Results Found" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description shown when no AI results are found */
            nlpEmptyDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.nlpEmptyDescription?c=6rllycdw6zhy", defaultMessage: "Try tweaking your search or see more results under Standard Results." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to switch to Standard Results with count */
            nlpEmptyButtonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.nlpEmptyButtonLabel?c=3bnh1u4p9mieg", defaultMessage: "View Standard Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title shown when no standard results are found */
            lexicalEmptyTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.lexicalEmptyTitle?c=32vbh5gk2yv8h", defaultMessage: "No Standard Results Found" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description shown when no standard results are found */
            lexicalEmptyDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.lexicalEmptyDescription?c=1imhx80n744bk", defaultMessage: "Try tweaking your search or see more results under AI Results." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to switch to AI Results with count */
            lexicalEmptyButtonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "QuickSearchTabEmptyState.lexicalEmptyButtonLabel?c=t7cvokap2dai", defaultMessage: "View AI Results ({count})" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
